import React from 'react'
import "./UserProfile.css";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ProfileSidebar from './ProfileSidebar';


export default function ChangePassword() {
  return (
    <div className='user_profile_wrapper pt-4 pb-4'>
      <div className='container'>
         <div className='user_profile_subblock'>
            <div className='row'>
              <div className='col-md-3'>
                    <div className='sidebar_profile'>
                      <ProfileSidebar/>
                    </div>
                </div>
                <div className='col-md-9'>
                <div className='changepassword_right'>

                    <div className='change_pwd_head mb-4'>
                      <h5 className='change_head'>Change Password</h5>
                    </div>
                  <div className='col-md-6'>
                    <Form name="" className="change_password_info">                      

                          <div className="form-control-pwd">
                            <input type="password" name="name" className="form-input-pwd" placeholder="none" required=""/>
                            <span className="fa fa-eye field-icon"></span>
                            <Form.Label className='form-label-pwd'>Old Password</Form.Label>
                          </div>


                          <div className="form-control-pwd">
                            <input type="password" name="name" className="form-input-pwd" placeholder="none" required=""/>
                            <Form.Label className='form-label-pwd'>New Password</Form.Label>
                          </div>


                          <div className="form-control-pwd">
                            <input type="password" name="name" className="form-input-pwd" placeholder="none" required=""/>
                            <Form.Label className='form-label-pwd'>Confirm Password</Form.Label>
                          </div>

                     

                          <div className='col-md-12 mt-4'>
                          <div className='prev_next_block'>
                            <Button className="previous_btn">
                              Cancel
                            </Button>
                            <Button className="next_btn">
                              Update Password
                            </Button>
                          </div>
                        </div>  

                    </Form>
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>    
    </div>
  )
}
